import { render, staticRenderFns } from "./EnterNewCase.vue?vue&type=template&id=8fe40ea6"
import script from "./EnterNewCase.vue?vue&type=script&lang=js"
export * from "./EnterNewCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports